export class Message {
    messageId: string;
    messageStatusCode: string;
    dateSent: Date;
    applicationName: string;
    messageFrom: string;
    toRoleCode: string;
    toUserId: string;
    subject: string;
    actionUrl: string;
}




// WEBPACK FOOTER //
// ./src/app/models/message.ts